import { Tooltip, useToast } from '@chakra-ui/react';
import { useState } from 'react';
import InputMask from 'react-input-mask';
import { useParams } from 'react-router-dom';

import { apiSensedia } from '../../../../services/api-sensedia';
import { LayoutLeadsSimple } from './components/LayoutLeadsSimple';

export const InserirLead = () => {
  const toast = useToast();
  const { idLeadOrigem } = useParams();

  const [nome, setNome] = useState('');
  const [codDoc, setCodDoc] = useState('');
  const [email, setEmail] = useState('');
  const [tipo, setTipo] = useState('');
  const [telefone, setTelefone] = useState('');
  const [telefoneTipo, setTelefoneTipo] = useState<'celular' | 'telefone'>(
    'celular'
  );

  const [documento, setDocumento] = useState('');
  const [documentoTipo, setDocumentoTipo] = useState<'cpf' | 'cnpj'>('cpf');

  const [mensagem, setMensagem] = useState('');
  const [anotacoes, setAnotacoes] = useState('');

  const [produtos, setProdutos] = useState<string[]>([]);

  // planos por produto
  const planosSaude = [
    'Prestige',
    'Executivo',
    'Especial Mais',
    'Especial 100',
    'Clássico',
    'Exato',
    'Direto Nacional',
    'Direto Regional'
  ];

  const codDocumentLabelMap = {
    Saúde: 'Código(s) de Contrato',
    Vida: 'Número(s) de Apólice',
    'Vida Coletivo': 'Número(s) de Apólice',
    Previdência: 'Número(s) de Apólice',
    Viagem: 'Número(s) de Apólice',
    Odonto: 'Número(s) de Contrato',
    'Odonto Empresa': 'Número(s) de Contrato',
    'Saúde PRC': 'Código(s) de Contrato'
  };

  const planosOdonto = ['Individual', 'PME', 'PME MAIS', 'Empresarial'];
  const planosVida = [
    'Acidentes pessoais',
    'Acidentes pessoais estagiários',
    'Vida simples',
    'Vida individual e Mulher',
    'Viagem',
    'Capital Global',
    'Você empresa',
    'Prestamista'
  ];

  const [selectedPlanSaude, setSelectedPlanSaude] = useState('');
  const [selectedPlanOdonto, setSelectedPlanOdonto] = useState('');
  const [selectedPlanVida, setSelectedPlanVida] = useState('');

  const getPlanosByProduto = (produto: string) => {
    switch (produto) {
      case 'Saúde':
        return planosSaude;
      case 'Odonto':
        return planosOdonto;
      case 'Vida':
        return planosVida;
      default:
        return [];
    }
  };

  const [loading, setLoading] = useState(false);

  const MAX_NOME = 40;
  const MAX_CODDOC = 80;
  const MAX_EMAIL = 40;
  const MAX_MSG = 300;
  const MAX_ANOT = 500;

  const handleProdutoChange = (produto: string) => {
    if (produtos.includes(produto)) {
      setProdutos(produtos.filter((p) => p !== produto));
      if (produto === 'Saúde') setSelectedPlanSaude('');
      if (produto === 'Odonto') setSelectedPlanOdonto('');
      if (produto === 'Vida') setSelectedPlanVida('');
    } else {
      setProdutos([...produtos, produto]);
    }
  };

  const resetForm = () => {
    setNome('');
    setEmail('');
    setTipo('');
    setTelefone('');
    setDocumento('');
    setMensagem('');
    setAnotacoes('');
    setTelefoneTipo('celular');
    setDocumentoTipo('cpf');
    setProdutos([]);
    setSelectedPlanSaude('');
    setSelectedPlanOdonto('');
    setSelectedPlanVida('');
    setCodDoc('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const builtMessageField = `Id do Lead de Origem: ${idLeadOrigem}\n${codDocumentLabelMap[tipo]}: ${codDoc}\n${mensagem}`;

      const body: any = {
        idLeadOrigem,
        nome,
        email,
        tipo,
        mensagem: builtMessageField,
        anotacoes,
        produtos: produtos ?? []
      };

      if (telefone) {
        body[telefoneTipo] = telefone;
      }
      if (documento) {
        body[documentoTipo] = documento;
      }

      if (selectedPlanSaude) body.plan_saude = selectedPlanSaude;
      if (selectedPlanOdonto) body.plan_odonto = selectedPlanOdonto;
      if (selectedPlanVida) body.plan_vida = selectedPlanVida;

      await apiSensedia.put(
        '/oportunidades-sulamerica/painel-leads/leads-manuais/inserir-novo',
        body,
        { timeout: 0 }
      );

      toast({
        title: 'Lead inserido!',
        description: 'O lead foi cadastrado com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });

      resetForm();
    } catch (err: any) {
      console.error('erro ao inserir lead', { err });
      if (err.response?.status === 504) {
        toast({
          title: 'Lead cadastrado',
          description:
            'O servidor demorou a responder, mas sua solicitação foi processada. Verifique no painel de gestão em instantes.',
          status: 'success',
          duration: 6000,
          isClosable: true,
          position: 'top'
        });

        resetForm();
      } else {
        const message = err.response?.status === 409 ? ': Lead duplicado' : '';
        toast({
          title: `Erro ao inserir lead${message}`,
          description:
            err.response?.data?.message ||
            'Não foi possível cadastrar o lead. Tente novamente.',
          status: 'error',
          duration: 6000,
          isClosable: true,
          position: 'top'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const requiresPlanos = produtos.some(
    (p) =>
      (p === 'Saúde' && !selectedPlanSaude) ||
      (p === 'Odonto' && !selectedPlanOdonto) ||
      (p === 'Vida' && !selectedPlanVida)
  );

  // validação dos obrigatórios
  const isFormValid =
    (idLeadOrigem ?? '').trim() !== '' &&
    nome.trim() !== '' &&
    email.trim() !== '' &&
    tipo.trim() !== '' &&
    codDoc.trim() !== '' &&
    telefone.trim() !== '' &&
    documento.trim() !== '' &&
    produtos.length > 0 && // exige produtos se venda realizada
    !requiresPlanos; // exige plano apenas se produto exige plano

  return (
    <LayoutLeadsSimple backUrl={'/corretor/leads/' + idLeadOrigem}>
      <div className="tw-bg-white tw-rounded-3xl tw-mt-[1.87rem] tw-p-[1.88rem]">
        <h1 className="tw-font-bold tw-text-[1.25rem] tw-text-[#323232] tw-mb-6">
          Inserir Lead
        </h1>

        <div className="tw-flex tw-flex-col tw-gap-5 tw-max-w-[40rem]">
          <div>
            <label className="tw-font-bold">
              Lead de origem <span className="tw-text-red-500">*</span>
            </label>
            <input
              type="text"
              value={idLeadOrigem}
              disabled
              className="tw-mt-1 tw-w-full tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none tw-bg-[#ebebeb] tw-cursor-not-allowed"
            />
          </div>

          {/* Nome */}
          <div>
            <label className="tw-font-bold">
              Nome <span className="tw-text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Ex: João da Silva"
              value={nome}
              onChange={(e) => {
                if (e.target.value.length <= MAX_NOME) setNome(e.target.value);
              }}
              className="tw-mt-1 tw-w-full tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
            />
            <div className="tw-flex tw-justify-end tw-text-[0.875rem] tw-text-[#5A5A5A]">
              {nome.length}/{MAX_NOME}
            </div>
          </div>

          {/* E-mail */}
          <div>
            <label className="tw-font-bold">
              E-mail <span className="tw-text-red-500">*</span>
            </label>
            <input
              type="email"
              placeholder="Ex: joao.silva@email.com"
              value={email}
              onChange={(e) => {
                if (e.target.value.length <= MAX_EMAIL)
                  setEmail(e.target.value);
              }}
              className="tw-mt-1 tw-w-full tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
            />
            <div className="tw-flex tw-justify-end tw-text-[0.875rem] tw-text-[#5A5A5A]">
              {email.length}/{MAX_EMAIL}
            </div>
          </div>

          {/* Celular/Telefone */}
          <div>
            <label className="tw-font-bold">
              Celular / Telefone <span className="tw-text-red-500">*</span>
            </label>
            <div className="tw-flex tw-gap-3 tw-mt-1">
              <select
                value={telefoneTipo}
                onChange={(e) =>
                  setTelefoneTipo(e.target.value as 'celular' | 'telefone')
                }
                className="tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3"
              >
                <option value="celular">Celular</option>
                <option value="telefone">Telefone</option>
              </select>

              <InputMask
                mask={
                  telefoneTipo === 'celular'
                    ? '(99) 99999-9999'
                    : '(99) 9999-9999'
                }
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
              >
                {(inputProps: any) => (
                  <input
                    {...inputProps}
                    placeholder={
                      telefoneTipo === 'celular'
                        ? 'Ex: (11) 98765-4321'
                        : 'Ex: (11) 3456-7890'
                    }
                    className="tw-flex-1 tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
                  />
                )}
              </InputMask>
            </div>
          </div>

          {/* Tipo */}
          <div>
            <label className="tw-font-bold">
              Tipo <span className="tw-text-red-500">*</span>
            </label>
            <select
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
              className="tw-mt-1 tw-w-full tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
            >
              <option value="">Selecione</option>
              <option value="Odonto">Odonto</option>
              <option value="Odonto Empresa">Odonto Empresa</option>
              <option value="Saúde">Saúde</option>
              <option value="Saúde PRC">Saúde PRC</option>
              <option value="Vida">Vida</option>
              <option value="Vida Coletivo">Vida Coletivo</option>
              <option value="Viagem">Viagem</option>
              <option value="Previdência">Previdência</option>
            </select>
          </div>

          {tipo ? (
            <div>
              <label className="tw-font-bold">
                {codDocumentLabelMap[tipo]}{' '}
                <span className="tw-text-red-500">*</span>
              </label>
              <Tooltip
                label="Para inserir mais de um dado, separe-os por vírgula."
                fontSize="sm"
              >
                <span className="tw-cursor-help tw-text-[#001E64]">ℹ️</span>
              </Tooltip>
              <input
                type="text"
                placeholder="Ex: 00000000, 11111111"
                value={codDoc}
                onChange={(e) => {
                  if (e.target.value.length <= MAX_CODDOC)
                    setCodDoc(e.target.value);
                }}
                className="tw-mt-1 tw-w-full tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
              />
              <div className="tw-flex tw-justify-end tw-text-[0.875rem] tw-text-[#5A5A5A]">
                {codDoc.length}/{MAX_CODDOC}
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* CPF/CNPJ */}
          <div>
            <label className="tw-font-bold">
              CPF / CNPJ <span className="tw-text-red-500">*</span>
            </label>
            <div className="tw-flex tw-gap-3 tw-mt-1">
              <select
                value={documentoTipo}
                onChange={(e) =>
                  setDocumentoTipo(e.target.value as 'cpf' | 'cnpj')
                }
                className="tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3"
              >
                <option value="cpf">CPF</option>
                <option value="cnpj">CNPJ</option>
              </select>

              <InputMask
                mask={
                  documentoTipo === 'cpf'
                    ? '999.999.999-99'
                    : '99.999.999/9999-99'
                }
                value={documento}
                onChange={(e) => setDocumento(e.target.value)}
              >
                {(inputProps: any) => (
                  <input
                    {...inputProps}
                    placeholder={
                      documentoTipo === 'cpf'
                        ? 'Ex: 123.456.789-00'
                        : 'Ex: 12.345.678/0001-99'
                    }
                    className="tw-flex-1 tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
                  />
                )}
              </InputMask>
            </div>
          </div>

          {/* Informações adicionais */}
          <div>
            <div className="tw-flex tw-items-center tw-gap-2">
              <label className="tw-font-bold">Informações adicionais</label>
              <Tooltip
                label="Insira os dados referentes ao lead, como número de proposta ou qualquer informação adicional."
                fontSize="sm"
              >
                <span className="tw-cursor-help tw-text-[#001E64]">ℹ️</span>
              </Tooltip>
            </div>
            <textarea
              value={mensagem}
              onChange={(e) => {
                if (e.target.value.length <= MAX_MSG)
                  setMensagem(e.target.value);
              }}
              placeholder={`Ex: Data de Nascimento: 00/00/0000\nSexo: Feminino`}
              className="tw-mt-1 tw-w-full tw-h-[8rem] tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
            />
            <div className="tw-flex tw-justify-end tw-text-[0.875rem] tw-text-[#5A5A5A]">
              {mensagem.length}/{MAX_MSG}
            </div>
          </div>

          {/* Produtos */}
          <div className="tw-flex tw-flex-col tw-gap-4">
            <label className="tw-font-bold">
              Produtos <span className="tw-text-red-500">*</span>
            </label>
            <div className="tw-flex tw-gap-6 tw-mt-2">
              {[
                'Odonto',
                'Saúde',
                'Saúde + Odonto',
                'Viagem',
                'Vida',
                'Previdência'
              ].map((produto) => (
                <label
                  key={produto}
                  className="tw-flex tw-items-center tw-gap-2"
                >
                  <input
                    type="checkbox"
                    checked={produtos.includes(produto)}
                    onChange={() => handleProdutoChange(produto)}
                  />
                  {produto}
                </label>
              ))}
            </div>

            {/* Planos dependentes dos produtos */}
            {produtos.map((produto) => {
              const planos = getPlanosByProduto(produto);
              if (planos.length === 0) return null;
              return (
                <div key={produto} className="tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-font-bold">
                    Plano {produto} <span className="tw-text-red-500">*</span>
                  </label>
                  <select
                    className="tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-[#001E64] tw-rounded-md tw-w-full"
                    value={
                      produto === 'Saúde'
                        ? selectedPlanSaude
                        : produto === 'Odonto'
                        ? selectedPlanOdonto
                        : selectedPlanVida
                    }
                    onChange={(e) => {
                      const val = e.target.value;
                      if (produto === 'Saúde') setSelectedPlanSaude(val);
                      if (produto === 'Odonto') setSelectedPlanOdonto(val);
                      if (produto === 'Vida') setSelectedPlanVida(val);
                    }}
                  >
                    <option value="">Selecione um plano</option>
                    {planos.map((plano, idx) => (
                      <option key={idx} value={plano}>
                        {plano}
                      </option>
                    ))}
                  </select>
                </div>
              );
            })}
          </div>

          {/* Anotações */}
          <div>
            <div className="tw-flex tw-items-center tw-gap-2">
              <label className="tw-font-bold">Anotações</label>
              <Tooltip
                label="Insira os detalhes referentes à percepção"
                fontSize="sm"
              >
                <span className="tw-cursor-help tw-text-[#001E64]">ℹ️</span>
              </Tooltip>
            </div>
            <textarea
              value={anotacoes}
              onChange={(e) => {
                if (e.target.value.length <= MAX_ANOT)
                  setAnotacoes(e.target.value);
              }}
              placeholder={`Ex: O cliente não teve interesse`}
              className="tw-mt-1 tw-w-full tw-h-[8rem] tw-border tw-border-[#001E64] tw-rounded-md tw-py-2 tw-px-3 focus:tw-outline-none"
            />
            <div className="tw-flex tw-justify-end tw-text-[0.875rem] tw-text-[#5A5A5A]">
              {anotacoes.length}/{MAX_ANOT}
            </div>
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading || !isFormValid}
            className="tw-bg-[#001E64] tw-text-white tw-rounded-2xl tw-py-2 tw-px-6 tw-w-[10rem] tw-font-bold hover:tw-bg-[#002b8a] disabled:tw-opacity-50"
          >
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </div>
      </div>
    </LayoutLeadsSimple>
  );
};
